<template>
  <div>
    <button v-show="isShow" class="btn" id="open-dialog" @click="onShowAction">{{ actionName }}</button>
    <div
      class="dialog fullscreen"
      data-trigger="#open-dialog"
      data-type="simple"
      ref="dialog">
      <div class="content">
        <div class="top">
          <div class="title">{{ headerName }}</div>
        </div>
        <div class="body">
          <slot name="dialog-body"></slot>
        </div>
        <div class="bottom" :class="isMandatory ? 'mandatory-block' : ''">
          <div v-if="isMandatory" class="mandatory-text">* mandatory field</div>
          <div>
            <button class="btn ghost" data-close="true" @click="onCancelAction">{{ cancelActionName }}</button>
            <button class="btn primary" @click="isMandatory ? onValidateAction() :  onOkAction()">{{ okActionName }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Dialog } from '@eds/vanilla';
import NotificationService from '@/helpers/notification';

export default {
  props: {
    actionName: {
      type: String,
      default: 'Create',
    },
    headerName: {
      type: String,
      default: 'Subscribe',
    },
    okAction: {
      type: Function,
    },
    validateAction: {
      type: Function
    },
    cancelAction: {
      type: Function
    },
    showAction: {
      type: Function
    },
    okActionName: {
      type: String,
      default: 'Submit'
    },
    cancelActionName: {
      type: String,
      default: 'Cancel'
    },
    isShow: {
      type: Boolean,
      default: true
    },
    isValid: {
      type: Boolean,
      default: true
    },
    isMandatory: {
      type: Boolean,
      default: false
    }
  },
  
  data() {
    return {
      dialog: Dialog,
    };
  },

  mounted() {
    this.initDialog();
  },

  methods: {
    initDialog() {
      this.dialog = new Dialog(this.$refs.dialog);
      this.dialog.init();
    },

    onOkAction() {
      this.okAction();
      this.dialog.hide();
    },

    onValidateAction() {
      if (this.validateAction()) {
        this.onOkAction();
      } else {
        NotificationService.error('Please fill in all mandatory fields. ');
        const notify = document.getElementsByClassName('notifications-wrapper');
        notify.item(0).style = "z-index: 101";
      }
    },

    onCancelAction() {
      this.cancelAction();
    },

    onShowAction() {
      this.showAction()
      this.dialog.show();
    }
  },
};
</script>

<style lang="less" scoped>
.content-dialog {
  max-width: fit-content;
}

.mandatory-block {
  display: flex !important;
  align-items: baseline;
  justify-content: space-between;
}

.mandatory-text {
  font-style: italic;
}
</style>